<tec-modal
	[isVisible]="isVisible"
	[title]="'GENERAL.ERROR.CHANGE_DEVICE_TITLE' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="(hasActiveRecording ? 'GENERAL.ERROR.CHANGE_DEVICE_DESCRIPTION_WITH_RECORDING' : 'GENERAL.ERROR.CHANGE_DEVICE_DESCRIPTION') | translate"></span>
		<tec-qr [url]="url" />
	</ng-container>
</tec-modal>